<div
  class="card-header flex-wrap border-0 pb-0"
  [ngClass]="{'pb-4': data.items.length <= 1}"
>
  <div class="me-3 mb-2">
    <p class="fs-14 mb-1">{{ data.type }}</p>
    <span class="fs-24 text-black font-w600">{{
      lastMonth.amount | currency : 'BRL'
    }}</span>
  </div>

  <span class="fs-12 mb-2" *ngIf="lastMonth.change">
    <img
      *ngIf="lastMonth.change >= 0"
      src="assets/icons/indicators/symbol-of-growth.svg"
    />
    <img
      *ngIf="lastMonth.change < 0"
      src="assets/icons/indicators/fall-symbol.svg"
    />
    {{ lastMonth.change }}% ({{
      'features.dashboard.cards.incomeOutgoingPeriod' | translate
    }})</span
  >
</div>

<div class="card-body p-0" *ngIf="data && data.items.length > 1">
  <canvas #chartCanvas height="80"></canvas>
</div>
